import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { API_ERROR_500 } from "../../../../config";
import { setLoading } from "../../../../redux/common/commonAction";
import { getStageScreen } from "../../../../redux";
import { validateIncomeProof } from "../IncomeProof/redux/action";
import {
  makeid,
  fileToBase64,
  AC_CHOKSI_API_URL,
  getApiUrl,
  getApiHeader,
  showPrevBtnByUrl,
  showNextBtnByUrl,
  getPrevAndNextRoute,
  CONSORTIUM_API_URL,
} from "utils";
import Webcam from "react-webcam";
import Title from "../../components/Title";
import Label from "../../components/Label";
import Button from "../../components/Button";
import TextInput from "../../components/TextInput";
import { getBankByIfsc } from "designs/v1/redux/services";
import "./style.css";
import InputTitle from "designs/v1/components/InputTitle";

const FACING_MODE_USER = "user";
const FACING_MODE_ENVIRONMENT = "environment";

const videoConstraints = {
  width: 220,
  height: 200,
  facingMode: FACING_MODE_USER,
};

const GET_IFSC_INFO_API = "https://ifsc.razorpay.com";

const WebcamCapture = ({ handleImg, handleShow, disabled, show }) => {
  const [facingMode, setFacingMode] = useState(FACING_MODE_USER);
  const [image, setImage] = useState("");
  const webcamRef = React.useRef(null);

  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
    handleImg(imageSrc);
  });

  const handleChangeMode = React.useCallback(() => {
    setFacingMode((prevState) =>
      prevState === FACING_MODE_USER
        ? FACING_MODE_ENVIRONMENT
        : FACING_MODE_USER
    );
  }, []);

  const handleClose = (bool) => {
    setImage("");
    handleShow(bool);
  };

  return (
    <>
      {show ? (
        <div className="webcam-container">
          <div className="webcam-img">
            {image == "" ? (
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width={"100%"}
                videoConstraints={{
                  ...videoConstraints,
                  facingMode,
                }}
              />
            ) : (
              <img
                src={image}
                alt=""
              />
            )}
          </div>
          <div>
            {image != "" ? (
              <>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setImage("");
                  }}
                  className="btn btn-success mx-2"
                >
                  Retake Image
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleClose(false);
                  }}
                  className="btn btn-warning mx-2"
                >
                  Close
                </button>
              </>
            ) : (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    capture();
                  }}
                  className="btn btn-success"
                >
                  Capture
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleClose(false);
                  }}
                  className="btn btn-warning mx-2"
                >
                  Close
                </button>
                {isMobile && (
                  <button
                    type="button"
                    onClick={handleChangeMode}
                    className="btn btn-secondary"
                  >
                    Switch camera
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <button
          className="btn btn-warning btn-sm"
          disabled={disabled}
          onClick={() => handleShow(true)}
        >
          Open Camera
        </button>
      )}
    </>
  );
};

const BankVerification = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading } = useSelector((state) => state.common);
  const { inputLabelColor, cancelChequeField, bankStatementField } =
    useSelector((state) => state.theme);
  const { kycStatus, kycPageName } = useSelector((state) => state.navigation);
  const PROOF_TYPES = ["Bank Statement", "Passbook", "Cancelled Cheque"];
  const [bankProof, setBankProof] = useState({
    type: "",
    file: "",
  });
  const [bankAccount, setBankAccount] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountType, setAccountType] = useState("Saving");
  const [branchName, setBranchName] = useState("");
  const [showCheckUpload, setShowCheckUpload] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const [micrCode, setMicrCode] = useState("");
  const [isShow, setIsShow] = useState(false);
  const [showChequeFields, setShowChequeFields] = useState(false);
  const [chequeAccountName, setChequeAccountName] = useState("");
  const [chequeAccountNumber, setChequeAccountNumber] = useState("");
  const [chequeBankName, setChequeBankName] = useState("");
  const [chequeIfsc, setChequeIfsc] = useState("");
  const [chequeBranch, setChequeBranch] = useState("");

  useEffect(() => {
    if (checkValidIFSC(ifsc)) {
      getDataFromIFSC();
    } else {
      setBankName("");
      setBranchName("");
      setMicrCode("");
    }
  }, [ifsc]);

  useEffect(() => {
    if (checkValidIFSC(chequeIfsc)) {
      getDataFromIFSCCheque();
    } else {
      setChequeBankName("");
      setChequeBranch("");
    }
  }, [chequeIfsc]);

  const checkValidIFSC = (ifsc) => {
    let reg = /[A-Z|a-z]{4}[0][a-zA-Z0-9]{6}$/;
    if (reg.test(ifsc)) {
      return true;
    } else {
      return false;
    }
  };

  const getDataFromIFSC = async () => {
    const ifscNumber = ifsc?.toUpperCase();
    try {
      const resp = await axios.get(`${GET_IFSC_INFO_API}/${ifscNumber}`);
      const { data } = resp;
      setBranchName(data?.BRANCH);
      setBankName(data?.BANK);
      setMicrCode(data?.MICR);
    } catch (error) {
      try {
        const resp = await getBankByIfsc({ ifsc_code: ifscNumber });
        const { data } = resp.data ?? {};
        setBranchName(data?.branch);
        setBankName(data?.bank_name);
        setMicrCode(data?.micr_code);
      } catch (error) {
        const { response } = error;
        const errorMsg = response?.data?.message ?? API_ERROR_500;
        setBranchName("");
        setBankName("");
        setMicrCode("");
        toast.error(`Error: ${errorMsg}`);
      }
    }
  };

  const getDataFromIFSCCheque = async () => {
    const ifscNumber = chequeIfsc?.toUpperCase();
    try {
      const resp = await axios.get(`${GET_IFSC_INFO_API}/${ifscNumber}`);
      const { data } = resp;
      setChequeBranch(data?.BRANCH);
      setChequeBankName(data?.BANK);
    } catch (error) {
      try {
        const resp = await getBankByIfsc({ ifsc_code: ifscNumber });
        const { data } = resp.data ?? {};
        setChequeBranch(data?.branch);
        setChequeBankName(data?.bank_name);
      } catch (error) {
        const { response } = error;
        const errorMsg = response?.data?.message ?? API_ERROR_500;
        setChequeBranch("");
        setChequeBankName("");
        toast.error(`Error: ${errorMsg}`);
      }
    }
  };

  const submitChequeDetails = () => {
    if (chequeBranch == "") {
      alert("Please enter IFSC Code.");
    } else if (chequeAccountName == "") {
      alert("Please enter account holder name.");
    } else if (chequeAccountNumber == "") {
      alert("Please enter account number.");
    } else {
      let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
      API_URL_NEW = API_URL_NEW
        ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
        : "";
      const token = window.sessionStorage.getItem("token");
      const headers = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Authorization: `Basic ${token}`,
        },
      };
      dispatch(setLoading(true));
      axios
        .post(
          `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_verification.api.update_bank_details`,
          {
            account_type: accountType,
            acc_name: chequeAccountName,
            acc_no: chequeAccountNumber,
            bank_name: chequeBankName,
            ifsc_code: chequeIfsc,
            branch: chequeBranch,
          },
          headers
        )
        .then((result) => {
          toast.success("Bank Account Verification Successful");
          dispatch(getStageScreen());
          dispatch(setLoading(false));
        })
        .catch((error) => {
          const { response } = error;
          dispatch(setLoading(false));
          if (response?.data?.message) {
            toast.error(response?.data?.message);
          } else {
            toast.error(API_ERROR_500);
          }
        });
    }
  };

  const uploadBankStatement = async (e) => {
    let file = e.target.files[0];
    if (!file) {
      e.target.value = null;
      setBankProof((prev) => ({ ...prev, file: "" }));
      return;
    }
    setBankProof((prev) => ({ ...prev, file: file }));
    const apiUrl = getApiUrl();
    const headers = getApiHeader();
    const allowed_types = ["application/pdf"];
    if (!allowed_types.includes(file.type)) {
      toast.error("Only Images are allowed (PDF )", "Error");
      e.target.value = null;
      setBankProof((prev) => ({ ...prev, file: "" }));
      return;
    }
    const fileSize = file.size / 1024 ** 2;
    if (fileSize >= 4) {
      toast.error("Error: Please upload a file smaller than 4MB");
      e.target.value = null;
      setBankProof((prev) => ({ ...prev, file: "" }));
      return;
    }
    let isEncrypted = false;
    dispatch(setLoading(true));
    try {
      const formData = new FormData();
      formData.append("file", file);
      const resp = await validateIncomeProof(formData);
      isEncrypted = resp.data?.message || false;
      dispatch(setLoading(false));
    } catch (error) { }
    if (isEncrypted) {
      toast.error("Please upload a file without password protected.");
      e.target.value = null;
      setBankProof((prev) => ({ ...prev, file: "" }));
      dispatch(setLoading(false));
      return;
    }
    const formData = new FormData();
    const base64File = await fileToBase64(file);
    formData.append("file", base64File);
    formData.append("file_type", "base64");
    try {
      await axios.post(
        `${apiUrl}/api/method/kyc_customizations.apis.kyc_verification.api.upload_passbook_statement`,
        formData,
        headers
      );
      dispatch(setLoading(false));
      toast.success("Bank statement uploaded successfully.");
      dispatch(getStageScreen());
    } catch (error) {
      const { response } = error;
      dispatch(setLoading(false));
      e.target.value = null;
      setBankProof((prev) => ({ ...prev, file: "" }));
      toast.error(
        response?.data?.message || "Invalid Bank Statement, Please try again."
      );
    }
  };

  const uploadCheque = async (e) => {
    let _file = e.target.files[0];
    if (_file) {
      setBankProof((prev) => ({ ...prev, file: _file }));
      let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
      API_URL_NEW = API_URL_NEW
        ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
        : "";
      const token = window.sessionStorage.getItem("token");
      const headers = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Authorization: `Basic ${token}`,
        },
      };
      const allowed_types = ["image/png", "image/jpeg"];
      if (!allowed_types.includes(_file.type)) {
        toast.error("Only Images are allowed ( JPG | PNG )", "Error");
        e.target.value = null;
        return;
      }
      const fileSize = _file.size / 1024 ** 2;
      if (fileSize >= 4) {
        toast.error("Error: Please upload a file smaller than 4MB");
        e.target.value = null;
        return;
      }
      if (_file.type === "application/pdf") {
        let isEncrypted = false;
        dispatch(setLoading(true));
        try {
          const formData = new FormData();
          formData.append("file", _file, makeid(6) + ".pdf");
          const resp = await validateIncomeProof(formData);
          isEncrypted = resp.data?.message || false;
        } catch (error) { }
        if (isEncrypted) {
          toast.error("Please upload a file without password protected.");
          e.target.value = null;
          dispatch(setLoading(false));
          return;
        }
        const formData = new FormData();
        formData.append("img", _file, makeid(6) + ".pdf");
        formData.append("file_type", "pdf");
        axios
          .post(
            `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_verification.api.upload_cancelled_cheque`,
            formData,
            headers
          )
          .then((result) => {
            toast.success("Cheque uploaded successfully.");
            const { data } = result.data;
            setChequeAccountName(data.acc_name);
            setChequeAccountNumber(data.acc_no);
            setChequeIfsc(data.ifsc_code?.slice(-11));
            setShowChequeFields(true);
            dispatch(setLoading(false));
          })
          .catch((error) => {
            const { response } = error;
            if (response?.data?.message) {
              toast.error(response?.data?.message);
            } else {
              toast.error("Invalid cheque, Please try again.");
            }
            dispatch(setLoading(false));
            e.target.value = null;
          });
      } else {
        const img = new Image();
        img.src = window.URL.createObjectURL(_file);
        img.onload = async () => {
          if (img.width >= 400 && img.height >= 350) {
            dispatch(setLoading(true));
            try {
              const base64File = await fileToBase64(_file);
              const formData = new FormData();
              formData.append("img", base64File?.split(",").pop());
              formData.append("file_type", "Base64");
              const resp = await axios.post(
                `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_verification.api.upload_cancelled_cheque`,
                formData,
                headers
              );
              const { data } = resp.data;
              setChequeAccountName(data.acc_name);
              setChequeAccountNumber(data.acc_no);
              setChequeIfsc(data.ifsc_code?.slice(-11));
              setShowChequeFields(true);
              dispatch(setLoading(false));
            } catch (error) {
              const { response } = error;
              toast.error(
                response?.data?.message || "Invalid cheque, Please try again."
              );
              dispatch(setLoading(false));
              e.target.value = null;
            }
          } else {
            e.target.value = null;
            return toast.error(
              `The image you uploaded is of lower resolution. Please upload a higher resolution image.`
            );
          }
        };
      }
    } else {
      setBankProof((prev) => ({ ...prev, file: "" }));
      e.target.value = null;
    }
  };
  const uploadPassbook = async (e) => {
    let _file = e.target.files[0];
    if (_file) {
      setBankProof((prev) => ({ ...prev, file: _file }));
      let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
      API_URL_NEW = API_URL_NEW
        ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
        : "";
      const token = window.sessionStorage.getItem("token");
      const headers = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Authorization: `Basic ${token}`,
        },
      };
      const allowed_types = ["image/png", "image/jpeg"];
      if (!allowed_types.includes(_file.type)) {
        toast.error("Only Images are allowed ( JPG | PNG )", "Error");
        e.target.value = null;
        return;
      }
      const fileSize = _file.size / 1024 ** 2;
      if (fileSize >= 4) {
        toast.error("Error: Please upload a file smaller than 4MB");
        e.target.value = null;
        return;
      }
      if (_file.type === "application/pdf") {
        let isEncrypted = false;
        dispatch(setLoading(true));
        try {
          const formData = new FormData();
          formData.append("file", _file, makeid(6) + ".pdf");
          const resp = await validateIncomeProof(formData);
          isEncrypted = resp.data?.message || false;
        } catch (error) { }
        if (isEncrypted) {
          toast.error("Please upload a file without password protected.");
          e.target.value = null;
          dispatch(setLoading(false));
          return;
        }
        const formData = new FormData();
        formData.append("img", _file, makeid(6) + ".pdf");
        formData.append("file_type", "pdf");
        //Added paramters to add bank details alongwith passbok
        formData.append("account_no", bankAccount);
        formData.append("ifsc", ifsc);
        formData.append("branch_name", branchName);
        axios
          .post(
            `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_verification.endpoints.upload_passbook.upload_passbook`,
            formData,
            headers
          )
          .then((result) => {
            toast.success("Passbook uploaded successfully.");
            // const { data } = result.data;
            // setChequeAccountName(data.acc_name);
            // setChequeAccountNumber(data.acc_no);
            // setChequeIfsc(data.ifsc_code?.slice(-11));
            // setShowChequeFields(true);
            // dispatch(setLoading(false));
            dispatch(getStageScreen());
          })
          .catch((error) => {
            const { response } = error;
            if (response?.data?.message) {
              toast.error(response?.data?.message);
            } else {
              toast.error("Invalid passbook, Please try again.");
            }
            // dispatch(getStageScreen());
            dispatch(setLoading(false));
            e.target.value = null;
          });
      } else {
        const img = new Image();
        img.src = window.URL.createObjectURL(_file);
        img.onload = async () => {
          if (img.width >= 400 && img.height >= 350) {
            dispatch(setLoading(true));
            try {
              const base64File = await fileToBase64(_file);
              const formData = new FormData();
              formData.append("img", base64File?.split(",").pop());
              formData.append("file_type", "Base64");
              formData.append("account_no", bankAccount);
              formData.append("ifsc", ifsc);
              formData.append("branch_name", branchName);
              const resp = await axios.post(
                `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_verification.endpoints.upload_passbook.upload_passbook`,
                formData,
                headers
              );
              // const { data } = resp.data;
              // setChequeAccountName(data.acc_name);
              // setChequeAccountNumber(data.acc_no);
              // setChequeIfsc(data.ifsc_code?.slice(-11));
              // setShowChequeFields(true);
              dispatch(getStageScreen());
              dispatch(setLoading(false));
            } catch (error) {
              const { response } = error;
              toast.error(
                response?.data?.message || "Invalid passbook, Please try again."
              );
              dispatch(setLoading(false));
              e.target.value = null;
            }
          } else {
            e.target.value = null;
            return toast.error(
              `The image you uploaded is of lower resolution. Please upload a higher resolution image.`
            );
          }
        };
      }
    } else {
      setBankProof((prev) => ({ ...prev, file: "" }));
      e.target.value = null;
    }
  };

  const handleShow = (bool) => {
    setIsShow(bool);
  };

  const handleCaptureCheque = (img) => {
    uploadCaptureCheque(img);
  };

  const uploadCaptureCheque = (file) => {
    dispatch(setLoading(true));
    let formData = new FormData();
    formData.append("img", file?.replace("data:image/jpeg;base64,", ""));
    formData.append("file_type", "Base64");
    let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
    API_URL_NEW = API_URL_NEW
      ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    axios
      .post(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_verification.api.upload_cancelled_cheque`,
        formData,
        headers
      )
      .then((result) => {
        toast.success("Cheque uploaded successfully.");
        const { data } = result.data;
        setChequeAccountName(data.acc_name);
        setChequeAccountNumber(data.acc_no);
        setChequeIfsc(data.ifsc_code?.slice(-11));
        setShowChequeFields(true);
        dispatch(setLoading(false));
        // handlePageName();
      })
      .catch((error) => {
        const { response } = error;
        if (response?.data?.message) {
          toast.error(response?.data?.message);
        } else {
          toast.error(API_ERROR_500);
        }
        dispatch(setLoading(false));
      });
  };

  const verifyBankDetails = () => {
    let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
    API_URL_NEW = API_URL_NEW
      ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    axios
      .get(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_flow.api.get_penny_drop_response`,
        headers
      )
      .then((result) => {
        toast.success("Bank Account Verification Successful");
        dispatch(setLoading(false));
        if (cancelChequeField === "No") {
          dispatch(getStageScreen());
        } else {
          setShowCheckUpload(true);
        }
      })
      .catch((error) => {
        dispatch(setLoading(false));
        setShowCheckUpload(true);
        const { response } = error;
        if (getApiUrl() === AC_CHOKSI_API_URL) {
          toast.error("Please upload bank proof.");
        } else {
          if (response?.data?.message) {
            toast.error(response?.data?.message);
          } else {
            toast.error(API_ERROR_500);
          }
        }
      });
  };

  const openPromtBox = async (msg) => {
    if (window.confirm(msg)) {
      let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
      API_URL_NEW = API_URL_NEW
        ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
        : "";
      const token = window.sessionStorage.getItem("token");
      const headers = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Authorization: `Basic ${token}`,
        },
      };
      dispatch(setLoading(true));
      let obj = {
        account_no: bankAccount,
        ifsc: ifsc,
        branch_name: branchName,
        need_pennydrop: true,
      };
      axios
        .post(
          `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_verification.api.penny_drop_transaction`,
          obj,
          headers
        )
        .then((result) => {
          if (result.data.code == 201) {
            toast.success("Bank Account Verification Successful");
            dispatch(setLoading(false));
            if (cancelChequeField === "No") {
              dispatch(getStageScreen());
            } else {
              setShowCheckUpload(true);
            }
          } else {
            setTimeout(() => {
              verifyBankDetails();
            }, 30000);
          }
        })
        .catch((error) => {
          const { response } = error;
          if (response?.data?.message) {
            toast.error(response?.data?.message);
          } else {
            toast.error(API_ERROR_500);
          }
          dispatch(setLoading(false));
          setShowCheckUpload(true);
        });
    }
  };

  const handleBankVerification = () => {
    if (bankAccount === "") {
      toast.error("Please enter account number.");
    } else if (branchName === "") {
      toast.error("Please enter IFSC Code.");
    } else if (
      showCheckUpload &&
      !bankProof.type &&
      getApiUrl() === AC_CHOKSI_API_URL
    ) {
      toast.error("Please Select Bank Proof.");
    } else if (showCheckUpload && !bankProof.file) {
      toast.error("Please Upload Bank Proof.");
    } else {
      let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
      API_URL_NEW = API_URL_NEW
        ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
        : "";
      const token = window.sessionStorage.getItem("token");
      const headers = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Authorization: `Basic ${token}`,
        },
      };
      dispatch(setLoading(true));
      let obj = {
        account_type: accountType,
        account_no: bankAccount,
        ifsc: ifsc,
        branch_name: branchName,
        bank_name: bankName,
        micr_code: micrCode,
      };
      axios
        .post(
          `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_verification.api.penny_drop_transaction`,
          obj,
          headers
        )
        .then((result) => {
          if (result.data.code == 201) {
            toast.success("Bank Account Verification Successful");
            dispatch(setLoading(false));
            if (cancelChequeField === "No") {
              dispatch(getStageScreen());
            } else {
              setShowCheckUpload(true);
            }
          } else {
            setTimeout(() => {
              verifyBankDetails();
            }, 30000);
          }
        })
        .catch((error) => {
          const { response } = error;
          if (response?.data?.message) {
            toast.error(response?.data?.message);
          } else {
            toast.error(API_ERROR_500);
          }
          dispatch(setLoading(false));
          setShowCheckUpload(true);
          if (response?.data?.code === 407) {
            openPromtBox(response?.data?.message);
          }
        });
    }
  };

  const onNumberInput = (evt) => {
    let charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
    }
  };

  const onNumberAndAlpha = (evt) => {
    let charCode = evt.which ? evt.which : evt.keyCode;
    if (
      charCode > 31 &&
      (charCode < 65 || charCode > 90) &&
      (charCode < 97 || charCode > 122) &&
      (charCode < 48 || charCode > 57)
    ) {
      evt.preventDefault();
    }
  };

  return (
    <React.Fragment>
      <div className="col-md-12 mb-5">
        <Title title="Bank Verification" />
      </div>
      {!showChequeFields && (
        <div className="col-md-6">
          <div className="col-md-12">
            <div className="form-group">
              <InputTitle title={"Account Type"} />
              <select
                className="form-select"
                onChange={(e) => setAccountType(e.target.value)}
                value={accountType}
              >
                <option>Saving</option>
                <option>Current</option>
              </select>
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <TextInput
                label="Account Number"
                placeholder="Enter Account Number"
                value={bankAccount}
                onChange={(e) => setBankAccount(e.target.value)}
                onKeyPress={onNumberInput}
                disabled={showChequeFields}
                maxLength={20}
              />
            </div>
          </div>

          <div className="col-md-12">
            <div className="form-group">
              <TextInput
                label="IFSC Code"
                placeholder="ex: HDFCXXXX1"
                value={ifsc.toUpperCase()}
                onChange={(e) => setIfsc(e.target.value)}
                onKeyPress={onNumberAndAlpha}
                disabled={showChequeFields}
                maxLength={11}
              />
              {/* {bankName != "" && (
                <span
                  className="text-uppercase text-dark"
                  style={{ fontSize: 11 }}
                >
                  {bankName}, {branchName}{" "}
                </span>
              )} */}
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <TextInput
                label="Bank Name"
                placeholder="Bank Name"
                value={bankName}
                // onChange={(e) => setBankAccount(e.target.value)}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <TextInput
                label="Branch Name"
                placeholder="Branch Name"
                value={branchName}
                // onChange={(e) => setBankAccount(e.target.value)}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <TextInput
                label="MICR Code"
                placeholder="Enter MICR Code"
                value={micrCode}
                onChange={(e) => setMicrCode(e.target.value)}
                disabled={showChequeFields}
              />
            </div>
          </div>
        </div>
      )}
      {showCheckUpload && (
        <>
          {getApiUrl() === AC_CHOKSI_API_URL ? (
            <div>
              <div className="col-md-6 mt-4">
                <Label label="Select Bank Proof" />
                <select
                  className="form-select"
                  onChange={(e) => {
                    setBankProof({
                      type: e.target.value,
                      file: "",
                    });
                  }}
                >
                  <option value={""}>Select an option</option>
                  {PROOF_TYPES.map((item) => {
                    return (
                      <option
                        key={item}
                        value={item}
                      >
                        {item}
                      </option>
                    );
                  })}
                </select>
              </div>
              {PROOF_TYPES.slice(0, 2).includes(bankProof.type) && (
                <div className="col-md-6">
                  <Label label={`Upload ${bankProof.type} (Pdf)`} />
                  <input
                    type="file"
                    accept="application/pdf"
                    className="form-control"
                    onChange={uploadBankStatement}
                  />
                </div>
              )}
              {PROOF_TYPES.slice(2).includes(bankProof.type) && (
                <>
                  <div className="col-md-6">
                    <Label label="Upload Cancelled Cheque (jpg, png, pdf)" />
                    <form encType="multipart/form-data">
                      <input
                        type="file"
                        accept="image/*,application/pdf"
                        className="form-control"
                        onChange={uploadCheque}
                      />
                    </form>
                  </div>
                  <div className="col-md-6 mt-4">
                    <div style={{ position: "relative" }}>
                      <WebcamCapture
                        handleImg={handleCaptureCheque}
                        handleShow={handleShow}
                        show={isShow}
                        disabled={isDisable}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          ) : (
            // NEED TO CODE FOR CONSURTIUM
            <>
              <div className="col-md-6">
                <InputTitle
                  title={"Upload Cancelled Cheque (jpg, png)"}
                  className={"mt-4 mb-1"}
                />
                <form encType="multipart/form-data">
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={uploadCheque}
                  />
                  <label className="my-1 text-muted text-sm">
                    <small>Maximum file size: 4 MB</small>
                  </label>
                </form>
              </div>
              {/* {getApiUrl() === CONSORTIUM_API_URL && ( */}
              <div className="col-md-6">
                <InputTitle
                  title={"Upload Passbook (jpg, png)"}
                  className={"mt-4 mb-1"}
                />
                <form encType="multipart/form-data">
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={uploadPassbook}
                  />
                  <label className="my-1 text-muted text-sm">
                    <small>Maximum file size: 4 MB</small>
                  </label>
                </form>
              </div>
              {/* )} */}
              {/* <div className="col-md-6 mt-4">
                <div style={{ position: "relative" }}>
                  <WebcamCapture
                    handleImg={handleCaptureCheque}
                    handleShow={handleShow}
                    show={isShow}
                    disabled={isDisable}
                  />
                </div>
              </div> */}
            </>
          )}

          {showChequeFields && (
            <>
              <div className="col-md-6">
                <TextInput
                  label="Name"
                  type="text"
                  className="form-control"
                  onChange={(e) => setChequeAccountName(e.target.value)}
                  value={chequeAccountName}
                  placeholder="Enter Name Here"
                />
              </div>
              <div className="col-md-6">
                <TextInput
                  label="Account Number"
                  type="text"
                  className="form-control"
                  onChange={(e) => setChequeAccountNumber(e.target.value)}
                  onKeyPress={onNumberInput}
                  value={chequeAccountNumber}
                  placeholder="Enter Account Number"
                  maxLength={20}
                />
              </div>
              <div className="col-md-6">
                <TextInput
                  label="IFSC Code"
                  type="text"
                  className="form-control"
                  onChange={(e) => setChequeIfsc(e.target.value)}
                  onKeyPress={onNumberAndAlpha}
                  value={chequeIfsc.toUpperCase()}
                  placeholder="Enter Bank Name"
                  maxLength={11}
                />
                <span style={{ fontSize: 10 }}>
                  {chequeBankName} {chequeBranch}
                </span>
              </div>
            </>
          )}
        </>
      )}
      <div className="col-md-12 mt-3">
        <div className="d-flex">
          {showPrevBtnByUrl(
            history.location.pathname,
            kycStatus,
            kycPageName
          ) && (
              <Button
                title="Previous"
                type="button"
                className="mx-1"
                handleClick={() => {
                  const route = getPrevAndNextRoute(
                    history.location.pathname.slice(1),
                    kycPageName
                  );
                  history.push(route.prev);
                }}
              />
            )}
          <Button
            title="Submit"
            type="button"
            disabled={loading}
            className="btn btn-success mx-1"
            handleClick={() => {
              if (showChequeFields) {
                submitChequeDetails();
              } else {
                handleBankVerification();
              }
            }}
          />
          {showNextBtnByUrl(
            history.location.pathname,
            kycStatus,
            kycPageName
          ) && (
              <Button
                title="Next"
                type="button"
                className="mx-1"
                handleClick={() => {
                  const route = getPrevAndNextRoute(
                    history.location.pathname.slice(1),
                    kycPageName
                  );
                  history.push(route.next);
                }}
              />
            )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default BankVerification;
